import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { subscription } from '../../common/requests/base.subscription.ts';

import { getReadingCrittersRealtimeClientUtil } from '../utils/clients/readingcritters-realtime.client.util.ts';

export const ON_TEXT_TO_SPEECH_CHUNK_RECEIVED = subscription({
  onTextToSpeechChunkReceived: [
    { id: input('id', 'ID!') },
    {
      id: true,
      chunk: true,
      isComplete: true,
      order: true,
    },
  ],
});

type OnTextToSpeechChunkReceivedSubscription = typeof ON_TEXT_TO_SPEECH_CHUNK_RECEIVED;

type OnTextToSpeechChunkReceivedSubscriptionVariables = VariablesOf<OnTextToSpeechChunkReceivedSubscription>;
export type OnTextToSpeechChunkReceivedSubscriptionResult = ResultOf<OnTextToSpeechChunkReceivedSubscription>;

export const onTextToSpeechChunkReceivedSubscriptionRequest = async (
  props: OnTextToSpeechChunkReceivedSubscriptionVariables,
  hooks: {
    onConnected: () => Promise<void> | void;
    onError: (error: Error) => Promise<void> | void;
    onData: (data: OnTextToSpeechChunkReceivedSubscriptionResult) => Promise<void> | void;
  }
): Promise<{
  onClose: () => Promise<void> | void;
}> => {
  const client = getReadingCrittersRealtimeClientUtil();

  return await client.subscribe<
    OnTextToSpeechChunkReceivedSubscriptionResult,
    OnTextToSpeechChunkReceivedSubscriptionVariables
  >(ON_TEXT_TO_SPEECH_CHUNK_RECEIVED, { id: props.id }, hooks, { useAuth: true });
};
